import { motion } from "framer-motion";

// A dramatic on-load curtain that peels away in two halves,
// then a signature word-mark reveal above the fold. ~1.6s total.
const bar = {
  initial: { scaleY: 1 },
  animate: (i) => ({
    scaleY: 0,
    transition: {
      delay: 0.9 + i * 0.06,
      duration: 0.9,
      ease: [0.83, 0, 0.17, 1],
    },
  }),
};

const IntroCurtain = () => (
  <motion.div
    aria-hidden
    className="fixed inset-0 z-[70] pointer-events-none"
    initial={{ opacity: 1 }}
    animate={{ opacity: 0 }}
    transition={{ delay: 1.9, duration: 0.01 }}
  >
    {/* Colored slats sweeping upward */}
    <div className="absolute inset-0 flex">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <motion.div
          key={i}
          custom={i}
          variants={bar}
          initial="initial"
          animate="animate"
          className={`flex-1 origin-top ${
            i % 2 === 0 ? "bg-[#140A3D]" : "bg-[#26155F]"
          }`}
        />
      ))}
    </div>

    {/* Centered brand seal that fades before the sweep */}
    <motion.div
      className="absolute inset-0 grid place-items-center text-white"
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 1, 1, 0] }}
      transition={{ duration: 1.3, times: [0, 0.2, 0.7, 1] }}
    >
      <div className="text-center">
        <p className="font-mono text-[10px] uppercase tracking-[0.4em] text-[color:var(--gold)]">
          MSME · MONEY · AI
        </p>
        <p className="mt-4 font-serif italic text-3xl md:text-5xl tracking-tight">
          Securing your money.
        </p>
      </div>
    </motion.div>
  </motion.div>
);

export default IntroCurtain;
